import React from 'react'
import { string, shape } from 'prop-types'

import ModelIcon from 'Pods/Shared/ModelIcon/ModelIcon'
import Cinema4DIcon from 'images/home/cinema-4d.webp'

function FormatFilterItem({ item }) {
  return (
    <a href={item.path} className="filter-item format-filter-item">
      <div className="filter-item__content">
        {item.icon === 'cinema-4d' ? (
          <img
            key={item.name}
            src={Cinema4DIcon}
            alt={item.name}
            width="24"
            height="24"
            loading="lazy"
            decoding="async"
          />
        ) : (
          <ModelIcon icon={item.icon} width="24" height="24" />
        )}
        <span className="filter-item__name">{item.name}</span>
        <div className="filter-item__count">{item.count}</div>
      </div>
      {item.extensions && (
        <div className="filter-item__meta">
          <span className="filter-item__ext">{item.extensions}</span>
        </div>
      )}
    </a>
  )
}

FormatFilterItem.propTypes = {
  item: shape({
    name: string.isRequired,
    count: string.isRequired,
    icon: string.isRequired,
    extensions: string,
    path: string.isRequired,
  }).isRequired,
}

FormatFilterItem.displayName = 'FormatFilterItem'

export default FormatFilterItem
